module.exports = __webpack_public_path__ + "static/scientist9-161f24a838c04287d8ab8429b138ccee.jpg";